module.exports = __webpack_public_path__ + "img/v1_santa_claus.b48d9cd1.svg";